// extracted by mini-css-extract-plugin
export var stats = "Stats-module--stats--ecf75";